import React from "react";

/** Brand diamonds spreading out once — played when a payment succeeds. */
export function DiamondBurst() {
  const pieces = Array.from({ length: 14 }, (_, i) => {
    const angle = (i / 14) * Math.PI * 2;
    const dist = 70 + (i % 3) * 26;
    return { x: Math.cos(angle) * dist, y: Math.sin(angle) * dist, d: (i % 4) * 40, s: 6 + (i % 3) * 2 };
  });
  return (
    <div className="burst" aria-hidden="true">
      {pieces.map((p, i) => (
        <i key={i} style={{ "--x": `${p.x}px`, "--y": `${p.y}px`, animationDelay: `${p.d}ms`, width: p.s, height: p.s } as React.CSSProperties} />
      ))}
    </div>
  );
}
